import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[iaInvalidControlScroll]',
  standalone: true,
})
export class InvalidControlScrollDirective {
  private readonly el = inject(ElementRef);

  private readonly formGroupDir = inject(FormGroupDirective);

  @HostListener('ngSubmit') public onSubmit(): void {
    if (this.formGroupDir.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

  private scrollToFirstInvalidControl(): void {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector('.ng-invalid');
    const yOffset = -180;
    const y = firstInvalidControl.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
